import { render, staticRenderFns } from "./qMsgMark.vue?vue&type=template&id=cc9e79ee&scoped=true"
import script from "./qMsgMark.vue?vue&type=script&lang=js"
export * from "./qMsgMark.vue?vue&type=script&lang=js"
import style0 from "./qMsgMark.vue?vue&type=style&index=0&id=cc9e79ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_8d78c4fc2b2e880cb3796fb82bca3a94/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc9e79ee",
  null
  
)

export default component.exports